import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Select from "@atlaskit/select";
import { isEqual } from "lodash";

const IssueTypeSelectList = ({ onSelectIssueType, selectedIssueType }) => {
  const [issueTypes, setIssueTypes] = useState([]);
  const [value, setValue] = useState("");

  const types = useSelector((state) => state.jira.issueTypes);

  useEffect(() => {
    //console.log("load issuetype", selectedIssueType);
    const options = types.map((it) => {
      return {
        label: (
          <div>
            <img src={it.iconUrl} width={16} height={16} />
            &nbsp;{it.name}
          </div>
        ),
        value: it.id,
      };
    });
    if (!isEqual(options, issueTypes)) {
      setIssueTypes(options);
    }
    if (selectedIssueType) {
      const option = options.find((o) => o.value == selectedIssueType);
      if (option) {
        setValue(option);
      }
    }
  }, [types, selectedIssueType]);

  const onSelect = (selectedValue) => {
    setValue(selectedValue);
    onSelectIssueType(selectedValue.value);
  };
  return (
    <Select
      inputId="jira-issue-type"
      className="ihub-jira-issue-type-list"
      options={issueTypes}
      value={value}
      placeholder="Select Issue Type"
      onChange={onSelect}
      isCompact={true}
    />
  );
};
export default IssueTypeSelectList;
